"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordResetCopy = void 0;
const onboardingHeroCopy_1 = require("./onboardingHeroCopy");
exports.passwordResetCopy = {
    header: 'Reset Your Password',
    input1: 'New Password',
    input2: 'Confirm New Password',
    cta: 'Reset',
    confirmation: 'Success!',
    prompt: 'Enter your new password',
    heroHeader: onboardingHeroCopy_1.onboardingHeroCopy.header,
    heroSubHeader: onboardingHeroCopy_1.onboardingHeroCopy.subHeader,
    errorTitle: 'Reset Password Error'
};
